import { useState } from 'react';
import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';

const useFunModeProps = (game?: SingleGameFragment) => {
  const isLoggedIn = useIsLoggedIn();
  const initialState = Boolean(game?.hasFunMode) && !isLoggedIn;
  const [isFunMode, setFunMode] = useState(initialState);
  return { isFunMode, setFunMode };
};

export default useFunModeProps;
